<div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between start">
  <h2>{{ "header.personalizar.ayudaPersonalizar.titulo" | translate }}</h2>
  <mat-icon (click)="cerrarModal()"  fxFlexAlign="start" style="cursor: pointer;">close</mat-icon>
</div>

<mat-dialog-content fxLayout="column" class="imc--pers-ajuda">

  <mat-card fxFlexOffset="2">
    <mat-card-title>
      <span>{{ "header.personalizar.ayudaPersonalizar.tarjetaAyuda.titulo" | translate }}</span>
    </mat-card-title>
    <mat-card-content>
      <ul fxLayout="column">
        <li fxLayoutAlign="space-between center" fxFlexOffset="2">
          <div fxFlex="25">{{ "header.personalizar.ayudaPersonalizar.tarjetaAyuda.colores.titulo" | translate }}</div>
          <div fxFlex="75">{{ "header.personalizar.ayudaPersonalizar.tarjetaAyuda.colores.descripcion" | translate }}</div>
        </li>
        <li fxLayoutAlign="space-between center" fxFlexOffset="2">
          <div fxFlex="25">{{ "header.personalizar.ayudaPersonalizar.tarjetaAyuda.elementos.titulo" | translate }}</div>
          <div fxFlex="75">{{ "header.personalizar.ayudaPersonalizar.tarjetaAyuda.elementos.descripcion" | translate }}</div>
        </li>
        <li fxLayoutAlign="space-between center" fxFlexOffset="2">
          <div fxFlex="25">{{ "header.personalizar.ayudaPersonalizar.tarjetaAyuda.ayudaPantalla.titulo" | translate }}</div>
          <div fxFlex="75">{{ "header.personalizar.ayudaPersonalizar.tarjetaAyuda.ayudaPantalla.descripcion" | translate }}</div>
        </li>
        <li fxLayoutAlign="space-between center" fxFlexOffset="2">
          <div fxFlex="25">{{ "header.personalizar.ayudaPersonalizar.tarjetaAyuda.opcionSeleccionada.titulo" | translate }}</div>
          <div fxFlex="75">{{ "header.personalizar.ayudaPersonalizar.tarjetaAyuda.opcionSeleccionada.descripcion" | translate }}</div>
        </li>
      </ul>
    </mat-card-content>
  </mat-card>

  <mat-card fxFlexOffset="2">
    <mat-card-title>
      <span>{{ "header.personalizar.ayudaPersonalizar.tarjetaAccesibilidad.titulo" | translate }}</span>
    </mat-card-title>
    <mat-card-content>
      <ul fxLayout="column">
        <li fxLayoutAlign="space-between center" fxFlexOffset="2">
          <div fxFlex="25">{{ "header.personalizar.ayudaPersonalizar.tarjetaAccesibilidad.general.titulo" | translate }}</div>
          <div fxFlex="75">{{ "header.personalizar.ayudaPersonalizar.tarjetaAccesibilidad.general.descripcion" | translate }}</div>
        </li>
        <li fxLayoutAlign="space-between center" fxFlexOffset="2">
          <div fxFlex="25">{{ "header.personalizar.ayudaPersonalizar.tarjetaAccesibilidad.botones.titulo" | translate }}</div>
          <div fxFlex="75">{{ "header.personalizar.ayudaPersonalizar.tarjetaAccesibilidad.botones.descripcion" | translate }}</div>
        </li>
        <li fxLayoutAlign="space-between center" fxFlexOffset="2">
          <div fxFlex="25">{{ "header.personalizar.ayudaPersonalizar.tarjetaAccesibilidad.cuadroCombinado.titulo" | translate }}</div>
          <div fxFlex="75">{{ "header.personalizar.ayudaPersonalizar.tarjetaAccesibilidad.cuadroCombinado.descripcion" | translate }}</div>
        </li>
        <li fxLayoutAlign="space-between center" fxFlexOffset="2">
          <div fxFlex="25">{{ "header.personalizar.ayudaPersonalizar.tarjetaAccesibilidad.menu.titulo" | translate }}</div>
          <div fxFlex="75">{{ "header.personalizar.ayudaPersonalizar.tarjetaAccesibilidad.menu.descripcion" | translate }}</div>
        </li>
        <li fxLayoutAlign="space-between center" fxFlexOffset="2">
          <div fxFlex="25">{{ "header.personalizar.ayudaPersonalizar.tarjetaAccesibilidad.pestanas.titulo" | translate }}</div>
          <div fxFlex="75">{{ "header.personalizar.ayudaPersonalizar.tarjetaAccesibilidad.pestanas.descripcion" | translate }}</div>
        </li>
        <li fxLayoutAlign="space-between center" fxFlexOffset="2">
          <div fxFlex="25">{{ "header.personalizar.ayudaPersonalizar.tarjetaAccesibilidad.botonOpcionMarcado.titulo" | translate }}</div>
          <div fxFlex="75">{{ "header.personalizar.ayudaPersonalizar.tarjetaAccesibilidad.botonOpcionMarcado.descripcion" | translate }}</div>
        </li>
        <li fxLayoutAlign="space-between center" fxFlexOffset="2">
          <div fxFlex="25">{{ "header.personalizar.ayudaPersonalizar.tarjetaAccesibilidad.casillaVerificacion.titulo" | translate }}</div>
          <div fxFlex="75">{{ "header.personalizar.ayudaPersonalizar.tarjetaAccesibilidad.casillaVerificacion.descripcion" | translate }}</div>
        </li>
        <li fxLayoutAlign="space-between center" fxFlexOffset="2">
          <div fxFlex="25">{{ "header.personalizar.ayudaPersonalizar.tarjetaAccesibilidad.calendario.titulo" | translate }}</div>
          <div fxFlex="75">{{ "header.personalizar.ayudaPersonalizar.tarjetaAccesibilidad.calendario.descripcion" | translate }}</div>
        </li>
        <li fxLayoutAlign="space-between center" fxFlexOffset="2">
          <div fxFlex="25">{{ "header.personalizar.ayudaPersonalizar.tarjetaAccesibilidad.agrupador.titulo" | translate }}</div>
          <div fxFlex="75">{{ "header.personalizar.ayudaPersonalizar.tarjetaAccesibilidad.agrupador.descripcion" | translate }}</div>
        </li>
      </ul>
    </mat-card-content>
  </mat-card>

</mat-dialog-content>